<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader="{ selectList }">
        <b-button
          v-if="selectList.length"
          variant="outline-danger"
          @click="groupDelete"
        >
          {{ $t("general.groupDelete") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>

      </template>

      <!-- Column: status -->
      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`articles.${item.status}`)"
          :width="110"
        />
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="$router.push({name: `pages-units-edit`,params: { id: item._id } })" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import '@/components/BDataTable/Actions/ViewRow.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import useUnitList from './useUnitList'

export default {
  name: 'UnitList',
  components: {
    BButton,
    BDataTable,
    EditRow,
    LayoutLoading,
    DeleteRow,
    PillIconCell,
  },
  setup() {
    const {
      deleteItem,
      fetchList,
      groupDelete,
      refTable,
      tableColumns,
      toEditPage,
      isSubmit,
    } = useUnitList()
    return {
      deleteItem,
      fetchList,
      groupDelete,
      refTable,
      tableColumns,
      toEditPage,
      PillIconCell,
      isSubmit,
    }
  },
}
</script>
